import React, {useState} from 'react'
import styles from '../coperateAccountPopUpcs.module.css'
import modalcancel from "../assets/icons/modal-cancel.svg";

export default function InfoPopup ({
    showPopup, setComingSoonPopup, popupText, dismisButtonText
}) {
    return (
        <div>
            {showPopup &&
                <div className={styles.popupBg}  onClick={() => setComingSoonPopup(false)}>
                 <div className={styles.popupContainer}>
                
                 <p className={styles.popupParagraph}>
                   {popupText}
                 </p>
                 <button
                     className={styles.popupButton}
                     onClick={() => setComingSoonPopup(false)}
                     >
                     {dismisButtonText}
                   </button>
                 </div>
              
           </div>
            }
        </div>
        
    )
}